/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Specification - Omobility app
 * OpenAPI documentation for Omobility app with Keycloak user authentication
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarDto } from '../model';
/**
 * CarControllerApi - axios parameter creator
 * @export
 */
export const CarControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a car by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/api/v1/car/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new car.
         * @param {CarDto} carDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1: async (carDto: CarDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carDto' is not null or undefined
            assertParamExists('create1', 'carDto', carDto)
            const localVarPath = `/api/v1/car`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a car to favorites
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favorite: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favorite', 'id', id)
            const localVarPath = `/api/v1/car/{id}/favorite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a car by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get1', 'id', id)
            const localVarPath = `/api/v1/car/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get favorite cars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorite: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/car/favorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a car by ID
         * @param {string} id 
         * @param {CarDto} carDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, carDto: CarDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'carDto' is not null or undefined
            assertParamExists('update', 'carDto', carDto)
            const localVarPath = `/api/v1/car/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarControllerApi - functional programming interface
 * @export
 */
export const CarControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a car by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarControllerApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new car.
         * @param {CarDto} carDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create1(carDto: CarDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create1(carDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarControllerApi.create1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a car to favorites
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favorite(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favorite(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarControllerApi.favorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a car by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get1(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarControllerApi.get1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get favorite cars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavorite(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavorite(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarControllerApi.getFavorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a car by ID
         * @param {string} id 
         * @param {CarDto} carDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, carDto: CarDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, carDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarControllerApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CarControllerApi - factory interface
 * @export
 */
export const CarControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a car by ID
         * @param {CarControllerApiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(requestParameters: CarControllerApiDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp._delete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new car.
         * @param {CarControllerApiCreate1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1(requestParameters: CarControllerApiCreate1Request, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.create1(requestParameters.carDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a car to favorites
         * @param {CarControllerApiFavoriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favorite(requestParameters: CarControllerApiFavoriteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.favorite(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a car by ID
         * @param {CarControllerApiGet1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1(requestParameters: CarControllerApiGet1Request, options?: RawAxiosRequestConfig): AxiosPromise<CarDto> {
            return localVarFp.get1(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get favorite cars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorite(options?: RawAxiosRequestConfig): AxiosPromise<Array<CarDto>> {
            return localVarFp.getFavorite(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a car by ID
         * @param {CarControllerApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters: CarControllerApiUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CarDto> {
            return localVarFp.update(requestParameters.id, requestParameters.carDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for _delete operation in CarControllerApi.
 * @export
 * @interface CarControllerApiDeleteRequest
 */
export interface CarControllerApiDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CarControllerApiDelete
     */
    readonly id: string
}

/**
 * Request parameters for create1 operation in CarControllerApi.
 * @export
 * @interface CarControllerApiCreate1Request
 */
export interface CarControllerApiCreate1Request {
    /**
     * 
     * @type {CarDto}
     * @memberof CarControllerApiCreate1
     */
    readonly carDto: CarDto
}

/**
 * Request parameters for favorite operation in CarControllerApi.
 * @export
 * @interface CarControllerApiFavoriteRequest
 */
export interface CarControllerApiFavoriteRequest {
    /**
     * 
     * @type {string}
     * @memberof CarControllerApiFavorite
     */
    readonly id: string
}

/**
 * Request parameters for get1 operation in CarControllerApi.
 * @export
 * @interface CarControllerApiGet1Request
 */
export interface CarControllerApiGet1Request {
    /**
     * 
     * @type {string}
     * @memberof CarControllerApiGet1
     */
    readonly id: string
}

/**
 * Request parameters for update operation in CarControllerApi.
 * @export
 * @interface CarControllerApiUpdateRequest
 */
export interface CarControllerApiUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CarControllerApiUpdate
     */
    readonly id: string

    /**
     * 
     * @type {CarDto}
     * @memberof CarControllerApiUpdate
     */
    readonly carDto: CarDto
}

/**
 * CarControllerApi - object-oriented interface
 * @export
 * @class CarControllerApi
 * @extends {BaseAPI}
 */
export class CarControllerApi extends BaseAPI {
    /**
     * 
     * @summary Delete a car by ID
     * @param {CarControllerApiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarControllerApi
     */
    public _delete(requestParameters: CarControllerApiDeleteRequest, options?: RawAxiosRequestConfig) {
        return CarControllerApiFp(this.configuration)._delete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new car.
     * @param {CarControllerApiCreate1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarControllerApi
     */
    public create1(requestParameters: CarControllerApiCreate1Request, options?: RawAxiosRequestConfig) {
        return CarControllerApiFp(this.configuration).create1(requestParameters.carDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a car to favorites
     * @param {CarControllerApiFavoriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarControllerApi
     */
    public favorite(requestParameters: CarControllerApiFavoriteRequest, options?: RawAxiosRequestConfig) {
        return CarControllerApiFp(this.configuration).favorite(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a car by ID
     * @param {CarControllerApiGet1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarControllerApi
     */
    public get1(requestParameters: CarControllerApiGet1Request, options?: RawAxiosRequestConfig) {
        return CarControllerApiFp(this.configuration).get1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get favorite cars
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarControllerApi
     */
    public getFavorite(options?: RawAxiosRequestConfig) {
        return CarControllerApiFp(this.configuration).getFavorite(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a car by ID
     * @param {CarControllerApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarControllerApi
     */
    public update(requestParameters: CarControllerApiUpdateRequest, options?: RawAxiosRequestConfig) {
        return CarControllerApiFp(this.configuration).update(requestParameters.id, requestParameters.carDto, options).then((request) => request(this.axios, this.basePath));
    }
}

